import api from "./api";

export default {
  async getSalarios() {
    return api.get("usuario/recibo_salarial");
  },
};
